module.exports = __webpack_public_path__ + "img/theBrands.25748348.svg";